var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"clipVideoSkeleton"},[_c('section',{staticClass:"clipVideoSkeleton-main"},[_c('skeleton-box',{staticClass:"clipVideoSkeleton-header"}),_c('skeleton-video',{attrs:{"show-controllers":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }